import defaultProfileImage from "../assets/images/icons/default-profile-image.svg";

export const setProfileImage = (profileImagePath: string | null | undefined) => {
  if (!profileImagePath) {
    return defaultProfileImage;
  } else {
    // The full URL of the image in the storage
    return profileImagePath;
  }
};
